import React from "react";

export default function TableSkeleton({ headers = [], rows }) {
  const colCount = headers.length || 5;

  // Default to 5 rows if not specified
  const skeletonRows = rows && rows > 0 ? rows : 5;

  return (
    <div className="overflow-x-auto rounded-2xl border bg-white shadow-sm animate-pulse">
      <table className="min-w-full text-sm">
        <thead className="bg-slate-50">
          <tr>
            {Array.from({ length: colCount }).map((_, i) => (
              <th key={i} className="px-3 py-2">
                <div className="h-3 bg-slate-200 rounded w-1/2"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: skeletonRows }).map((_, ri) => (
            <tr key={ri} className="border-b last:border-0">
              {Array.from({ length: colCount }).map((_, ci) => (
                <td key={`${ri}-${ci}`} className="px-3 py-2">
                  <div className="h-3 bg-slate-200 rounded w-full"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
